import BemIt from "@gtechdoodler/bem-it";
import Icon from "../../../../../imagery/Icon";
import Link from "../../../../../actions/Link";
import Snippet from "../ListItemSnippet/ListItemSnippet";
import { ListItemLinkSnippetProps } from "./ListItemLinkSnippet.types";

const ListItemLinkSnippet: React.FC<ListItemLinkSnippetProps> = ({
	children,
	...props
}) => {
	const block = new BemIt("ListItemLinkSnippet");
	return (
		<Snippet className={block.out}>
			<Link {...props}>
				{children}
				<Icon name="chevron-right" size="md" color="accent" />
			</Link>
		</Snippet>
	);
};

export default ListItemLinkSnippet;
